import { ProductJsonLd } from "next-seo"

export const JsonLdProduct = () => {
  const siteUrl = process.env.NEXT_PUBLIC_APP_URL

  return (
    <ProductJsonLd
      type="WebApplication"
      productName="Traqq"
      applicationCategory="BusinessApplication"
      datePublished="2019-01-15T23:21:55.000Z"
      operatingSystem="Web platform, Windows, Mac OS, Linux"
      description="AI-powered time tracker and smart time tracking software that works as hard as you do. Lightweight, free and packed with productivity-boosting insights."
      url={siteUrl}
      images={[`${siteUrl}/traqq-time-tracker-features.png`]}
      offers={[
        {
          price: "0",
          priceCurrency: "USD",
        },
      ]}
      featureList={`${siteUrl}/features/`}
      screenshot={`${siteUrl}/traqq-attendance-insights.png`}
      aggregateRating={{
        ratingValue: "4.8",
        ratingCount: "103",
      }}
      reviews={[
        {
          type: "Person",
          author: "Sarvarbek Yuldashev",
          datePublished: "2023-05-24",
          description:
            "Traqq's customizations and easy UI have been a valuable addition to our workflow. The anti-cheating algorithm ensures our team members are accountable and focused on their tasks.",
          name: "In our logistics company",
          reviewRating: {
            bestRating: "5",
            ratingValue: "5",
            worstRating: "1",
          },
        },
        {
          type: "Person",
          author: "Lauren Hinchliff",
          datePublished: "2023-06-12",
          description:
            "Traqq provides detailed reports and diverse analytics. It's helpful to see data on user productivity and consolidated team productivity.",
          name: "Recommended for diverse analytics",
          reviewRating: {
            bestRating: "5",
            ratingValue: "4",
            worstRating: "1",
          },
        },
      ]}
      softwareHelp={`${siteUrl}/support`}
      author={{
        "@type": "Organization",
        name: "Traqq Pty Ltd.",
        url: `${siteUrl}`,
        logo: {
          "@type": "ImageObject",
          url: `${siteUrl}/logo180.png`,
          width: "180px",
          height: "180px",
        },
      }}
      video={{
        "@type": "VideoObject",
        caption: "Traqq: Time Tracker for on-site and remote teams",
        thumbnailUrl: "https://i.ytimg.com/vi/SNFKyh62lJo/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLCMS0SR490EqyiMUYh2UVwkrc1eKQ",
        contentUrl: "https://www.youtube.com/watch?v=SNFKyh62lJo",
        name: "Traqq Time Tracker Tour",
        description: "A 2-minute video showing how you can track time and productivity with Traqq software",
        uploadDate: "2023-06-12T00:00:00.000Z",
      }}
    />
  )
}
